import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'replace'
})

export class ReplacePipe implements PipeTransform {
  transform(value: any, pattern, replacement): any {
    const reg = new RegExp(pattern, 'g');
    return value.replace(reg, replacement);
  }
}
